import styles from './FJImageEnhancerLeft.module.less';
import PropTypes from 'prop-types';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJImageEnhancerCard from '../../FJImageManipulation/FJImageEnhancerCard/FJImageEnhancerCard';
import FJImageEnhancerInputContainer from '../FJImageEnhancerInput/FJImageEnhancerInputContainer';
import FJImageEnhancerFileListContainer from '../FJImageEnhancerFileList/FJImageEnhancerFileListContainer';
import FJLocalStore from '../../../store/FJLocalStore';
import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJUtil from '../../../util/FJUtil';
import { IMAGE_ENHANCER_USE_CREDIT } from '../../../redux/slices/FJSliceImageEnhancer';
import { useRef, useEffect } from 'react';
const FJImageEnhancerLeft = props => {
    const {
        onGenerate,
        taskStatus,
        freeNumCreation,
        creditNumber,
        upscale,
        onChangeImageType,
        onChangeZoom,
        isProjectLoading,
        uploadImageList,
    } = props;

    const generateButtonRef = useRef(null);

    const useCredit = Math.max(uploadImageList.length * IMAGE_ENHANCER_USE_CREDIT, IMAGE_ENHANCER_USE_CREDIT);
    const isFree = freeNumCreation > 0 && creditNumber < useCredit && uploadImageList.length <= 1;
    const isShowUploadList = uploadImageList.length > 0;
    const disabled = FJUtil.isGeneratingStatus(taskStatus);

    useEffect(() => {
        generateButtonRef.current?.hideUsageDetail();
    }, [uploadImageList]);

    return (
        <FJAppLeft>
            <FJImageEnhancerInputContainer />
            {isShowUploadList && (
                <>
                    <div className={styles.title}>{FJLocalStore._('images')}</div>
                    <FJImageEnhancerFileListContainer />
                    <div className={styles.line_through}></div>
                </>
            )}
            <FJImageEnhancerCard
                active={true}
                upscale={upscale}
                onChangeImageType={onChangeImageType}
                onChangeZoom={onChangeZoom}
                isSingle={true}
                disabled={disabled}
            />
            <FJGenerateButton
                ref={generateButtonRef}
                onClick={onGenerate}
                taskStatus={taskStatus}
                isFree={isFree}
                freeNumCreation={freeNumCreation}
                useCredit={useCredit}
                isShowUsageDetail={isShowUploadList ? true : false}
                isProjectLoading={isProjectLoading}
            />
        </FJAppLeft>
    );
};
FJImageEnhancerLeft.propTypes = {
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    upscale: PropTypes.number,
    onChangeImageType: PropTypes.func,
    onChangeZoom: PropTypes.func,
    isProjectLoading: PropTypes.bool,
    uploadImageList: PropTypes.array,
};
export default FJImageEnhancerLeft;
